import { useState } from 'react';


const CaseConverter = () => {
  const [text, setText] = useState('');
  const [convertedText, setConvertedText] = useState('');


  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleConvert = (type ) => {
    switch (type) {
      case 'lowercase':
        setConvertedText(text.toLowerCase());
        break;
      case 'uppercase':
        setConvertedText(text.toUpperCase());
        break;
      case 'titlecase':
        setConvertedText(text.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '));
        break;
      case 'sentencecase':
        setConvertedText(text.charAt(0).toUpperCase() + text.slice(1).toLowerCase());
        break;
      default:
        break;
    }
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label


  const handleCopy = () => {
    navigator.clipboard.writeText(convertedText);
    setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
  };



  const handleClear = () => {
    setText('');
    setConvertedText('');
  };


     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(text);


  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
  
    <div className="form-group">
      <label htmlFor="textInput">Enter your text here  </label>
      <textarea
        id="textInput"
        className="form-control mb-3"
        rows="4"
        value={text}
        style={{ height: '10rem' }}
        onChange={handleTextChange}
        placeholder="Enter your text here "
      />
    </div>
  
    <div className="btn-group mb-4" role="group">
      <button className="btn btn-outline-primary" onClick={() => handleConvert('lowercase')}>
      Convert To Lowercase

      </button>
      <button className="btn btn-outline-primary" onClick={() => handleConvert('uppercase')}>
      Convert To Uppercase

      </button>
      <button className="btn btn-outline-primary" onClick={() => handleConvert('titlecase')}>
      Convert to Title Case
      </button>
      <button className="btn btn-outline-primary" onClick={() => handleConvert('sentencecase')}>
      Convert To Sentence Case
      </button>
    </div>
  

    <p className="font-weight-bold">Converted Text:  </p>
    <textarea
        id="text"
        className="form-control mb-3"
        rows="4"
        value={convertedText}
        style={{ height: '10rem' }}
        placeholder="Converted Text: "
      />
       

  <div className="d-flex align-items-center">
      <button className="btn btn-primary" onClick={handleCopy}>
      {copyButtonLabel}
      </button>
      <button
        className="btn btn-danger "
        onClick={handleClear}
      >
     Clear
      </button>
    </div>
       <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
  </div>
  
  );
};

export default CaseConverter;